// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { itemListStyles } from "@tps/Overrides/Widgets/Basic/ItemList";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

itemListStyles.itemListWrapper = {
    css: css`
        text-align: right;
        text-transform: capitalize;
        padding: 10px 0;
    `,
};

itemListStyles.pagination = {
    cssOverrides: {
        perPageSelect: css`
            ${xScreen("lte", "md")} {
                width: auto;
            }
        `,
    },
    selectProps: {
        mergeCss: true,
        cssOverrides: {
            formInputWrapper: css`
                max-width: unset;
                width: auto;
            `,
        },
        labelProps: {
            css: css`
                width: auto;
                padding: 3px 8px 0 0;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
    },
};
